import React from "react";

import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function ContactDetails(props) {
    const {
        title = "",
        text = "",
        content_type = "",
        contact_detail_image = "",
        contact_detail_url = "",
    } = props;

    return (
        <Section className={style.contactDetails}>
            <div className={style.sectionRow}>
                <div className={`${style.sectionColumn} ${style.textContent}`}>
                    {
                        text !== "" && title !== "" && (
                            <>
                                <Title
                                    transform="uppercase"
                                    tag="h1"
                                    className="fontTeko"
                                >
                                    {title}
                                </Title>
                                <Spacer size="32" />
                                <Editor text={text} />
                            </>
                        )
                    }
                </div>
                <div className={`${style.sectionColumn} ${style.mapColumn}`}>
                    {
                        content_type === "image" && contact_detail_image !== "" && (
                            <div className={style.mapImagewarp}>
                                <Background src={contact_detail_image} size="796x640" cPosition="bottomRight" />
                            </div>
                        )
                    }
                    {
                        content_type === "map" && contact_detail_url !== "" && (
                            <div className={style.mapImagewarp}>
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={contact_detail_url}
                                    title="Map Display"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        )
                    }
                </div>
            </div>
        </Section>
    )
}
